import React from 'react';

import { ProjectItem } from '../types';

import { ProjectCard } from './ProjectCard';

interface ProjectsGridProps {
  items: ProjectItem[];
  onProjectClick: (item: ProjectItem) => void;
  onStarClick?: (item: ProjectItem) => void;
  starredItems?: Set<string>;
  onUploadClick?: (item: ProjectItem) => void;
  onRemoveImage?: (item: ProjectItem) => void;
}

export const ProjectsGrid: React.FC<ProjectsGridProps> = ({
  items,
  onProjectClick,
  onStarClick,
  starredItems,
  onUploadClick,
  onRemoveImage
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
      {items.map((item) => (
        <ProjectCard
          key={item.id}
          item={item}
          onClick={() => onProjectClick(item)}
          onStarClick={onStarClick}
          isStarred={starredItems?.has(item.id) || false}
          onUploadClick={onUploadClick}
          onRemoveImage={onRemoveImage}
        />
      ))}
    </div>
  );
};
